<template>
  <div class="gantt mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/EG001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navNine')}}</h1>
                <div style="float:right;display:flex;align-items: center;">
                  <label style="margin-right:10px;font-size:12px;">{{$t('gantt.labelTitle')}}</label>
                  <!-- <el-cascader
                  class="idStyle"
                  :placeholder="$t('gantt.placehoder1')"
                  expand-trigger="hover"
                  :options="options"
                  filterable
                  v-model="machineID">
                </el-cascader> -->
                  <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                </div>
              </div>
              <!-- 甘特图 -->
              <div class="seach">
                <el-date-picker
                  v-model="datePicker"
                  type="datetimerange"
                  @change="clearDis"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="——"
                  :start-placeholder="$t('gantt.StartTime')"
                  :end-placeholder="$t('gantt.EndTime')">
                </el-date-picker>
                <img v-if="machineStatus === 5 || machineStatus === 0" style="vertical-align:middle; margin-left:10px; cursor: not-allowed;float:right;" src="../assets/img/gantt/RefreshDis.png">                
                <div v-else style="display:inline-block;float:right;">
                  <img @click="autoChange()" v-show="auteState === 1" style="vertical-align:middle; margin-left:10px; cursor: pointer;" src="../assets/img/gantt/Refresh.png">
                  <img @click="autoChange()" v-show="auteState === 2" style="vertical-align:middle; margin-left:10px; cursor: pointer;" src="../assets/img/gantt/autoRefresh.gif">
                </div>
                <el-button @click="opendialogVisible" type="primary" style="margin-left:10px;">{{$t('gantt.selectStep')}}</el-button>
                <el-button @click="toView" style="float:right;" type="primary" icon="el-icon-view">{{$t('gantt.showBtn')}}</el-button>
              </div>
              <!-- 甘特图 -->
              <!-- <div v-show="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentData')}}</div> -->
              <div id="chartWrap" style="width:100%; margin-bottom:30px;" >
                <div v-show="machineTitle !== '' && $store.state.lang===0" class="chartTitle">{{'Gantt of ' + machineTitle + ' Events'}}</div>
                <div v-show="machineTitle !== '' && $store.state.lang===1" class="chartTitle">{{machineTitle + ' 的事件甘特图'}}</div>
                <div id="myChart" style="width:85%;height:1200px; margin:0 auto;"></div>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
    <!-- 弹出框 -->
    <el-dialog
      :title="$t('gantt.dialogTitle')"
      :visible.sync="dialogVisible"
      width="630px"
      :before-close="handleClose"
      class="selectStep">
      <el-transfer
        filterable
        target-order='push'
        :titles="[this.$t('gantt.dialogListTitle1'), this.$t('gantt.dialogListTitle2')]"
        :filter-placeholder="$t('gantt.placehoder2')"
        ref="my-transfer"
        v-model="transferVal"
        :data="transferData"
        v-loading="loading"
        :render-content="renderFunc"
        >
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{$t('gantt.dialogCancel')}}</el-button>
        <el-button type="primary" @click="handleconfirm()">{{$t('gantt.dialogOk')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
// import { Loading } from 'element-ui'

export default {
  name: 'gantt',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      // 选择的时间
      datePicker: null,
      // 获取的甘特图数据
      ganttData: '',
      // 显示隐藏弹出框
      dialogVisible: false,
      // 穿梭框结果
      selectTransfer: [],
      transferData: [],
      transferVal: [],
      selectMachineID: '',
      dlMachineID: '',
      factoryId: '',
      fullscreenLoading: false,
      transferList: '',
      // 刷新图标路径
      autoIcon: 'true',
      autoRotate: 'false',
      auteState: 0,
      autoInterval: '',
      ganttChart: null,
      resizeTimer: null,
      machineTitle: '',
      machineStatus: null,
      pickerMinDate: '',
      // 时间快捷键
      pickerOptions: {
        onPick: ({minDate}) => {
            this.pickerMinDate = minDate.getTime()
          },
          disabledDate: (time) =>{
            if (this.pickerMinDate !== '') {
              const day7 = 7 * 24 * 3600 * 1000
              let maxTime = this.pickerMinDate + day7
              let minTime = this.pickerMinDate - day7
              return (time.getTime() > maxTime ||
                        time.getTime() < minTime)
            } else {
              return ''
            }
          },
        shortcuts: [{
          text: this.$t('EventRecord.pickTime1'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 4);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('EventRecord.pickTime2'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 8);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // 穿梭框的loading
      loading:false,
      show:false,
      // noMachine:false
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
    machineID(){
      this.transferVal=[]
    }
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getManiceList()
    this.getTime()
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }
  },
  destroyed() {
    clearInterval(this.resizeTimer)
    clearInterval(this.autoInterval)
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[0]=Number(this.$store.state.defaultFactoryId)
      this.machineID[1]=Number(value)
      this.transferVal=[]
    },
    // 鼠标滑到穿梭框上的数据时，显示完整内容
    renderFunc(h,option){
      return  <el-tooltip class="item" effect="light" content={option.label} placement="bottom-start" enterable={false}>
                  <span>{option.label}</span>
              </el-tooltip>
      // return <span title={option.label}>{option.label}</span>
    },
    getTime(){
      function format(st){
        var time = new Date(st);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y+'-'+checkTime(m)+'-'+checkTime(d)+' '+checkTime(h)+':'+checkTime(mm)+':'+checkTime(s);
      }
      function checkTime(i){
        if (i<10) {
          i="0" + i
        }
        return i
      }
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/getServerTime'
      }).then(function (res) {
        var timestamp=res.data
        var oldTimestamp = timestamp - 28800000
        let nowDate = format(timestamp)
        let oldDate = format(oldTimestamp)
        let dateArr = [oldDate,nowDate]
        _this.datePicker = dateArr
      })
      

    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(res.data.options !==undefined && res.data.options.length > 0 ){
            // _this.noMachine=false
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options
          }
          //else{
          //   _this.noMachine=true
          // }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 获取穿梭框数据
    getTransferData(){
      let _this = this
      _this.loading = true
      this.axios({
        method: 'POST',
        url: '/url/findMachineMsgCodesList',
        params: {
          machineId: _this.selectMachineID, // 机器的id
          startTime: _this.datePicker[0],
          endTime: _this.datePicker[1],
          language:_this.$store.state.lang
        }
      }).then(function(res){
        
        const data = [];
        const cities = res.data
        cities.forEach((city) => {
          data.push({
            label: city,
            key: city
          });
        });
        _this.transferData = data
        // _this.transferVal = []
        
      }).then(function(){
        _this.loading = false
        _this.dialogVisible = true
        _this.$refs['my-transfer'].clearQuery('left')
        _this.$refs['my-transfer'].clearQuery('right')
      })
    },
    // 导出甘特图数据
    excelExport(){
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        this.urlData = '?machineId=' + this.dlMachineID + '&codes=' + this.transferList + '&startTime=' + this.datePicker[0] + '&endTime=' + this.datePicker[1] + '&factoryId=' + this.factoryId + '&flag=1' + '&language=' + this.$store.state.lang+'&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        window.open('/url/excelExportGanttChartData' + this.urlData, '_blank')
    },
    // 获取甘特图数据
    getData(){
      let _this = this
      let newlist=[]
      let str=''
      let data=_this.transferList
      let list = data.split(",")
      for(let k in list){
        newlist.push(list[k].split('-')[0])
      }
      for(var i=0;i<newlist.length;i++){
        str+=newlist[i]+','
      }
      str = str.substring(0, str.lastIndexOf(','))
      _this.transferList = str
      this.axios({
        method: 'POST',
        url: '/url/findGanttChartData',
        params: {
          language: _this.$store.state.lang,
          factoryId: _this.factoryId,
          machineId: _this.selectMachineID, // 机器的id
          codes: _this.transferList, // code
          startTime: _this.datePicker[0],
          endTime: _this.datePicker[1],
          flag: 1 // 1：不自动获取2：自动获取数据
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.dialogVisible = false
          _this.ganttData = res.data
          _this.initChart()
          _this.auteState = 1
          if(_this.autoInterval){
              clearInterval(_this.autoInterval)
          }
          _this.machineTitle = res.data.machineInfo.equipmentName + '(' +res.data.machineInfo.nameEn +')'
          _this.machineStatus = res.data.machineInfo.machineStatus
        } else {
          _this.$message.error(_this.$t('gantt.error'));
        }
        _this.fullscreenLoading = false;
      })
    },
    // 甘特图初始化
    initChart(){
      let _this = this
      this.ganttChart = this.$echarts.init(document.getElementById('myChart'))
      var HEIGHT_RATIO = 0.6;
      var DIM_CATEGORY_INDEX = 0;
      var DIM_TIME_ARRIVAL = 5;
      var DIM_TIME_DEPARTURE = 6;
      
      var _rawData = _this.ganttData
      this.ganttChart.setOption({
        tooltip: {
        },
        animation: false,
        toolbox: {
          show: true,
          itemSize:30,
          feature: {
            saveAsImage: {
              name: 'Gantt of Events',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUVGMkVDN0U0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUVGMkVDN0Q0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PlZeJAAAAM1BMVEX////h4eEoJib8/Pzj4+OysbHu7u75+flLSkr+/v5+fn7d3d3MzMzq6urp6env7++VlZXRcGIdAAAAZ0lEQVR42tyTSw6AIAwFH6WtogLe/7SaGDeghY2JOutJm34egrIzYA3Q5GHgUwabxu4wHBq4byvDRETyBmWlk+W2ihzCOBuNpDLqvUhpXKxOCuORA/QM/Yuv64iaRjuwMaMd+02AAQA9ewKBbQnBzgAAAABJRU5ErkJggg=='
            },
            myTool2:{
              show: _this.$store.state.authority.PageDownload.show,
              title:' ',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3OUE4Mzk1ODYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3OUE4Mzk1OTYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTgzOTU2NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjc5QTgzOTU3NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dmf26AAAAWpJREFUeNpivHfvHhsDA0M3EMcAsRADfcF7IF4MxKUsQKKLk5MzT1RUlIGZmZmurvj796/g69ev874DAROQHzsQjgABkJ0gu4EgFeQQoYFwBLJjQG5gYhgkgIUYRVdvPmZYvngmw+fPn/GqMzc3Z4iKiiLLIUSFCDGOAIGTJ08yLFu2jHYhAnPExIkTcarJz8+HOwYESA0ZmqQRckKGZomVVMfQNNeQ4hiaZ19YmqFKYiUGYEvIsAQ8KEJkyDmEoqjZuWMHw7bt28FsL09PBncPj6EfIkM7as6dO8ewcOFCFDFQFIEwuRUfWSFiZGTEEB8fT//alxjHUOIIinMNyDEgcOPGDYocQZWSFeQYmINo7hBeXl5wm4SUIhsG5OXkqJdGgoKCiDYQ3QMOjo7UCxFqBf+QKVnfAXtcA+YAqN3vQA5Z/ObNG4aBcMyfP38YQHYDwRxQGin79u0b46NHj2KBbMEB6oTXAgQYAEk/geeSh3YUAAAAAElFTkSuQmCC',
              option:{},
              onclick:function() {
                _this.excelExport()
              }
            }
          }
        },
        dataZoom: [{
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'weakFilter',
            height: 20,
            width: '75%',
            top: 10,
            left:100,
            start: 74,
            end: 100,
            handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            showDetail: false
        }, {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'weakFilter',
            height: 20,
            width: '75%',
            bottom: 0,
            left:100,
            start: 74,
            end: 100,
            handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            showDetail: false
        },{
            type: 'inside',
            id: 'insideX',
            xAxisIndex: 0,
            filterMode: 'weakFilter',
            start: 74,
            end: 100,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
        }],
        grid: {
            show: true,
            top: 70,
            bottom: 20,
            left: 100,
            right: 35,
            backgroundColor: '#fff',
            borderWidth: 0
        },
        xAxis: {
            type: 'time',
            position: 'top',
            splitLine: {
                lineStyle: {
                    color: ['#E9EDFF']
                }
            },
            axisLine: {
                show: false
            },
            axisTick: {
                lineStyle: {
                    color: '#929ABA'
                }
            },
            axisLabel: {
                color: '#929ABA',
                inside: false,
                align: 'center',
                formatter: function(value){
                  var date = new Date();
                  date.setTime(value);
                  var y = date.getFullYear();    
                  var m = date.getMonth() + 1;
                  m = m < 10 ? ('0' + m) : m;    
                  var d = date.getDate();    
                  d = d < 10 ? ('0' + d) : d;    
                  var h = date.getHours();  
                  h = h < 10 ? ('0' + h) : h;  
                  var minute = date.getMinutes();  
                  var second = date.getSeconds();  
                  minute = minute < 10 ? ('0' + minute) : minute;    
                  second = second < 10 ? ('0' + second) : second;
                  return y + '-' + m + '-' + d+'\n'+h+':'+minute+':'+second;
                }
            }
        },
        yAxis: {
            axisTick: {show: false},
            splitLine: {show: false},
            axisLine: {show: false},
            axisLabel: {show: false},
            min: 0,
            max: _rawData.parkingApron.data.length
        },
        series: [{
            id: 'flightData',
            type: 'custom',
            renderItem: renderGanttItem,
            dimensions: _rawData.flight.dimensions,
            encode: {
                x: [DIM_TIME_ARRIVAL, DIM_TIME_DEPARTURE],
                y: DIM_CATEGORY_INDEX
            },
            tooltip:{
              formatter:function(params){
                // 时间戳格式化
                function dateformatter(value){
                  var date = new Date();
                  date.setTime(value);
                  var y = date.getFullYear();    
                  var m = date.getMonth() + 1;
                  m = m < 10 ? ('0' + m) : m;    
                  var d = date.getDate();    
                  d = d < 10 ? ('0' + d) : d;    
                  var h = date.getHours();  
                  h = h < 10 ? ('0' + h) : h;  
                  var minute = date.getMinutes();  
                  var second = date.getSeconds();  
                  minute = minute < 10 ? ('0' + minute) : minute;    
                  second = second < 10 ? ('0' + second) : second;
                  return y + '-' + m + '-' + d+'\n'+h+':'+minute+':'+second;
                }
                return _this.$t('gantt.label1')+'：' + params.value[1] + '<br/>' +
                        _this.$t('gantt.label2')+'：' + params.value[2] + '<br/>' +
                        _this.$t('gantt.label3')+'：'+ params.value[3] + '<br/>' +
                        _this.$t('gantt.label4')+'：'+ params.value[4] + '<br/>' +
                        _this.$t('gantt.label5')+'：'+dateformatter(params.value[5])+ '<br/>' +
                        _this.$t('gantt.label6')+'：'+dateformatter(params.value[6])+ '<br/>' +
                        _this.$t('gantt.label7')+'：'+params.value[7]
              }
            },
            data: _rawData.flight.data
        }, {
            type: 'custom',
            renderItem: renderAxisLabelItem,
            dimensions: ['index','EventCode','Event'],
            encode: {
                x: -1, // Then this series will not controlled by x.
                y: 0
            },
            tooltip:{
              formatter:function(params){
                return  _this.$t('gantt.label1')+'：' + params.value[1] + '<br/>' +
                        _this.$t('gantt.label2')+'：'+ params.value[2] + '<br/>' +
                        _this.$t('gantt.label3')+'：'+ params.value[3] + '<br/>' +
                        _this.$t('gantt.label4')+'：'+ params.value[4]
              }
            },
            data: _this.$echarts.util.map(_rawData.parkingApron.data, function (item, index) {
                return [index].concat(item);
            })
        }]
      })

      function renderGanttItem(params, api) {
          var categoryIndex = api.value(DIM_CATEGORY_INDEX);
          var timeArrival = api.coord([api.value(DIM_TIME_ARRIVAL), categoryIndex]);
          var timeDeparture = api.coord([api.value(DIM_TIME_DEPARTURE), categoryIndex]);
          
          

          var barLength = timeDeparture[0] - timeArrival[0];
          // Get the heigth corresponds to length 1 on y axis.
          var barHeight = api.size([0, 1])[1] * HEIGHT_RATIO;
          var x = timeArrival[0];
          var y = timeArrival[1] - barHeight;

          var flightNumber = api.value(7);
          var flightNumberWidth = _this.$echarts.format.getTextRect(flightNumber).width;
          var text = (barLength > flightNumberWidth + 40 && x + barLength >= 180)
              ? flightNumber : '';

          var rectNormal = clipRectByRect(params, {
              x: x, y: y, width: barLength, height: barHeight
          });

          var rectText = clipRectByRect(params, {
              x: x, y: y, width: barLength, height: barHeight
          });

          return {
              type: 'group',
              children: [{
                  type: 'rect',
                  ignore: !rectNormal,
                  shape: rectNormal,
                  style: api.style({
                    fill: '#085ba6'
                  })
              }, {
                  type: 'rect',
                  ignore: !rectText,
                  shape: rectText,
                  style: api.style({
                      fill: 'transparent',
                      stroke: 'transparent',
                      text: text,
                      textFill: '#fff'
                  })
              }]
          };
      }
      function test(val){
        if (isNaN(val)){
          return ''
        } else{
          return val
        }
      }

      function renderAxisLabelItem(params, api) {
          var y = api.coord([0, api.value(0)])[1];
          if (y < params.coordSys.y + 5) {
              return;
          }
          return {
              type: 'group',
              position: [
                  5,
                  y
              ],
              children: [{
                  type: 'path',
                  shape: {
                      d: 'M6,0 C0,0 0,2 0,10 C0,16 0,20 6,20 L58,20 C64,20 64,16 64,10 C64,4 64,0 58,0',
                      x: 0,
                      y: -20,
                      width: 90,
                      height: 20,
                      layout: 'cover'
                      
                  },
                  style: {
                      fill: '#1d254e',
                  }
              }, {
                  type: 'text',
                  style: {
                      x: 24,
                      y: -2,
                      fontSize: 14,
                      text: test(api.value(1)),
                      textVerticalAlign: 'bottom',
                      textAlign: 'center',
                      textFill: '#fff'
                  }
              }]
          };
      }


      function clipRectByRect(params, rect) {
          return _this.$echarts.graphic.clipRectByRect(rect, {
              x: params.coordSys.x,
              y: params.coordSys.y,
              width: params.coordSys.width,
              height: params.coordSys.height
          });
      }

      this.resizeTimer = setInterval(function(){
        _this.ganttChart.resize()
      },500)
    },
    // 关闭弹出框
    handleClose(){
      // this.transferVal = []
      this.dialogVisible = false
    },
    handleconfirm(){
      if (this.transferVal.length > 64){
         this.$message.error(this.$t('gantt.error3'));
      } else if(this.transferVal.length === 0){
         this.$message.error(this.$t('gantt.error4'));
      }else{
        this.dialogVisible=false
      }
    },
    autoChange(){
      let _this = this
      if (this.auteState ===1){
        this.auteState = 2
        this.autoInterval= setInterval(function(){
          _this.noEndTime()
        },8000)
        
      } else if(this.auteState === 2){
        this.auteState = 1
        this.getcurrentdate()
        clearInterval(this.autoInterval)
      }
    },
    // 没有结束时间的数据
    noEndTime(){
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/findGanttChartData',
        params: {
          language: _this.$store.state.lang,
          factoryId: _this.factoryId,
          machineId: _this.selectMachineID, // 机器的id
          codes: _this.transferList, // code
          startTime: _this.datePicker[0],
          endTime: _this.datePicker[1],
          flag: 2 // 1：有结束时间2：没有结束时间
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.ganttData = res.data
          _this.initChart()
          _this.ganttChart.setOption({
            dataZoom:[
                {
                    start:75,
                    end:100
                }
            ]
          })
        }
      })
    },
    clearDis(){
      if (this.datePicker === null) {
        this.pickerMinDate = ''
      }
    },
    //查看按钮
    toView(){
      let id = this.machineID[this.machineID.length-1]
      let date= this.datePicker
      if (id === undefined) {
        this.$message.error(this.$t('gantt.error1'));
      } else if(date === null){
        this.$message.error(this.$t('gantt.error2'));
      }else if(this.transferVal.length === 0){
        this.$message.error(this.$t('gantt.error5'));
      }else if(id !== undefined && date !== null && this.transferVal.length>0){
        this.transferList = this.transferVal.toString()
        this.dlMachineID = this.machineID[1].toString()
        this.selectMachineID = id.toString()
        this.getData()
        this.fullscreenLoading = true;
      }
    },
    // 打开选择步序的弹框
    opendialogVisible(){
      let id = this.machineID[this.machineID.length-1]
      let date= this.datePicker
      if (id === undefined) {
        this.$message.error(this.$t('gantt.error1'));
      } else if(date === null){
        this.$message.error(this.$t('gantt.error2'));
      }else{
        this.dialogVisible=true
        this.selectMachineID = id.toString()
        this.factoryId = this.machineID[0]
        this.getTransferData()
      }
    },
    // 获取当前时间
    getcurrentdate(){
      var date = new Date()
      var seperator1 = "-"
      var seperator2 = ":"
      //以下代码依次是获取当前时间的年月日时分秒
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var minute = date.getMinutes()
      var hour = date.getHours()
      var second = date.getSeconds()
      //固定时间格式
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      if (hour >= 0 && hour <= 9) {
          hour = "0" + hour
      }
      if (minute >= 0 && minute <= 9) {
          minute = "0" + minute
      }
      if (second >= 0 && second <= 9) {
          second = "0" + second
      }
      var currentdate =  year + seperator1 + month + seperator1 + strDate + " " + hour + seperator2 + minute + seperator2 + second
      var dateArr=[this.datePicker[0],currentdate]
      this.datePicker = dateArr
    }
  }
}
</script>
<style>
  .el-transfer-panel__item{
    padding-left:0!important;
  }
  .el-transfer-panel__body{
    padding-left:10px;
  }
  .selectStep .el-dialog__body{
    padding-bottom:50px;
  }
</style>
<style scoped>
.record{
  height: 100%;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 20px;
}
.seach label{
  margin-right:10px;
  font-size: 14px!important;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin: 5px 0 15px;
}
/* .noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
} */
</style>

